/* @flow */

import * as React from 'react';

import {ReactionBar, AddReactionButton} from '../../reaction-bar';
import type {Reaction, Reactions} from '../../reaction-bar';
import {type EmailEngagementProps, EmailEngagement} from './index';

import './email-engagement-reaction-bar.css';

// EmailEngagementReactionBarProps
export type Props = {|
    // Email engagement props
    emailEngagement?: {...EmailEngagementProps},
    disableReactions?: boolean,
|};

type OwnProps = {|
    ...Props,
    reactions?: Reactions,
    alwaysShowAddButton?: boolean,
    currentUserId?: string,
    onToggleReaction?: (reaction: Reaction) => any,
|};

export function EmailEngagementReactionBar(props: OwnProps) {
    const {
        emailEngagement: emailEngagementProps,
        alwaysShowAddButton,
        disableReactions,
        currentUserId,
        onToggleReaction,
        reactions,
    } = props;

    const hasEmailEngagement = Boolean(
        emailEngagementProps &&
            (emailEngagementProps.attachments.length ||
                emailEngagementProps.opens ||
                emailEngagementProps.clicks)
    );
    const hasReactions = Boolean(reactions && Object.keys(reactions).length);
    const canRenderReactionBar = Boolean(
        !disableReactions && hasReactions && onToggleReaction && currentUserId
    );

    return hasEmailEngagement || hasReactions || alwaysShowAddButton ? (
        <div
            styleName='email-engagement-reaction-bar'
            className={`flex ${hasEmailEngagement ? 'justify-sb' : 'justify-end'}`}
        >
            {hasEmailEngagement ? (
                <div styleName='engagement-container'>
                    <EmailEngagement {...emailEngagementProps} />
                </div>
            ) : (
                undefined
            )}
            {canRenderReactionBar ? (
                <ReactionBar
                    // $FlowIgnore - hasReactions checks for this
                    reactions={reactions}
                    // $FlowIgnore - canRenderReactionBar checks for this
                    currentUserId={currentUserId}
                    // $FlowIgnore - canRenderReactionBar checks for this
                    onToggleReaction={onToggleReaction}
                />
            ) : (
                undefined
            )}
            {alwaysShowAddButton && !hasReactions && onToggleReaction ? (
                <AddReactionButton onSelectReaction={onToggleReaction} />
            ) : (
                undefined
            )}
        </div>
    ) : null;
}
